import { Form } from '@homex/se-react-components';
import styled from 'styled-components/macro';

import { large } from 'styles/breakpoints';
import { containerTall, containerWide } from 'styles/layout';
import { headingForm } from 'styles/typography';
import { IWithThemeProps } from 'typings';

export const FormGroup = styled(Form)`
  ${containerTall}
`;

export const Buttons = styled.div`
  ${containerWide}
`;

export const Container = styled.div`
  ${containerWide}

  margin-bottom: 58px;
  margin-top: 21px;
  min-height: 200px;
  padding: 0 9px;
  text-align: left;

  ${large`
    margin-top: 18px;
    padding: 0;
  `}
`;

export const Subhead = styled.h2`
  ${headingForm}

  margin: 0 0 11px;
  text-transform: uppercase;

  ${({ theme }: IWithThemeProps) => `
    color: ${theme.bottomForegroundPrimary};
  `}
`;
